import {useContext, Fragment} from 'react';

import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

import {Grid, Typography} from '@mui/material';

import {useApplicantMatches} from '../hooks/useApplicantMatches';

import {CultureOverview} from './culture-overview/CultureOverview';
import {DashboardFooterSection} from './dashboard-footer/DashboardFooterSection';
import ApplicantMatches from './matches/ApplicantMatches';
import {LockedCultureTypeBanner} from '../../../../components/Banner/LockedCultureTypeBanner/LockedCultureTypeBanner';
import {ErrorMessage} from '../../../../components/ErrorMessage/ErrorMessage';
import {LoadingContainer} from '../../../../components/Loading/LoadingContainer';
import {UserContext} from '../../../../contexts/UserContext/UserContext';
import {useApplicantCultureType} from '../../../../hooks/useApplicantCultureType';
import {AppConfig} from '../../../../lib/AppConfig';
import {ApplicantRoleData} from '../../../../types/User';

export default function ApplicantDashboard() {
  const {currentUser} = useContext(UserContext);
  const {t} = useTranslation();

  const {
    loading: isApplicantLoading,
    data,
    error: matchError,
  } = useApplicantMatches((currentUser?.role.data as ApplicantRoleData)?.applicantId || '');
  const {cultureInformation, loading: isCultureInfoLoading, error: cultureError} = useApplicantCultureType();
  const navigate = useNavigate();
  const isDataLoading = isApplicantLoading && isCultureInfoLoading;
  const handleReadMore = () => {
    navigate(AppConfig.APPLICANT_CULTURE_PATH);
  };

  if (matchError || cultureError) {
    return <ErrorMessage />;
  }

  return (
    <Fragment>
      <Typography
        variant='h1'
        sx={{
          color: 'text.secondary',
          mb: 4,
        }}
      >
        {t('applicantDashboard.header')}
      </Typography>
      {isDataLoading || !data ? (
        <LoadingContainer minHeight={'374px'} />
      ) : (
        <>
          <ApplicantMatches matches={data} />
          <Grid item mt={{xs: '40px', md: '80px'}}>
            {cultureInformation ? (
              <CultureOverview cultureInformation={cultureInformation} onClick={handleReadMore} />
            ) : (
              <LockedCultureTypeBanner />
            )}
          </Grid>
          <DashboardFooterSection />
        </>
      )}
    </Fragment>
  );
}
